var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":_vm.formId}},[_vm._v(_vm._s(_vm.label)),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(" " + _vm.errorMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }